import { isAfter, differenceInMilliseconds } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

export const dynamicCountdown = (start_at, end_at) => {
  if (!start_at || !end_at) return null;

  const TIMEZONE = '+08:00';
  const now = utcToZonedTime(new Date(), TIMEZONE);
  const startDate = utcToZonedTime(new Date(start_at), TIMEZONE);
  const endDate = utcToZonedTime(new Date(end_at), TIMEZONE);

  if (isAfter(now, endDate)) {
    return null;
  }

  let status = null;
  let remainingMs = 0;

  if (isAfter(now, startDate)) {
    status = 'happening_now';
  } else {
    remainingMs = differenceInMilliseconds(startDate, now);
    const totalHours = remainingMs / (1000 * 60 * 60);

    if (totalHours > 72) {
      return null;
    } else if (totalHours > 48) { // 3 days to 2 days
      status = 'next_to_2_days';
    } else if (totalHours > 24) { // 2 days to 1 day
      status = 'tomorrow';
    } else { // under 24 hours
      status = 'today';
    }
  }

  const days = Math.floor(remainingMs / (1000 * 60 * 60 * 24));
  const hours = Math.floor((remainingMs / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((remainingMs / 1000 / 60) % 60);
  const seconds = Math.floor((remainingMs / 1000) % 60);

  return { status, days, hours, minutes, seconds };
};
